/* eslint-disable max-len */
import { shouldRenderMobileApp } from 'utils/detect-environment';
import {
    BACKEND_ACCOUNT_LOCKED_ERROR_CODE,
    BACKEND_INACTIVE_ACCOUNT_ERROR_CODE,
    BACKEND_INTERNET_CONN_ERROR_CODE,
    BACKEND_INVALID_CREDENTIALS_ERROR_CODE,
    BACKEND_RECAPTCHA_ERROR_CODE,
    BACKEND_UNKNOWN_ERROR_CODE,
} from 'features/authentication/utils/constants';

export const getInvalidCredentialsErrorMessage = () => {
    const isMobile = shouldRenderMobileApp();
    const mobileErrorMessage = 'Invalid username and password. \nPlease try again';
    const desktopErrorMessage =
        'The email or password you entered did not match our records. Please double-check and try again.';
    return isMobile ? mobileErrorMessage : desktopErrorMessage;
};

export const isAccountLockedError = (errorCode: number) => {
    return errorCode === BACKEND_ACCOUNT_LOCKED_ERROR_CODE;
};

export const getErrorText = (errorCode: number): string => {
    switch (errorCode) {
        case BACKEND_INACTIVE_ACCOUNT_ERROR_CODE:
            return getInvalidCredentialsErrorMessage();
        case BACKEND_INVALID_CREDENTIALS_ERROR_CODE:
            return 'Your account is not active yet. The activation email sent to your email again. Please contact support@placer.ai for assistance.';
        case BACKEND_RECAPTCHA_ERROR_CODE:
            return 'reCAPTCHA protection failed. Please refresh the page and try again. Contact support@placer.ai if issue repeats.';
        case BACKEND_ACCOUNT_LOCKED_ERROR_CODE:
            return 'Account locked: Too many incorrect attempts';
        case BACKEND_INTERNET_CONN_ERROR_CODE:
            return 'Please check your internet connection.';
        case BACKEND_UNKNOWN_ERROR_CODE:
            return 'Something wrong. Please contact support@placer.ai for assistance.';
        default:
            return '';
    }
};
